module.exports = __webpack_public_path__ + "img/icon-check.6a130937.svg";